module.exports = __webpack_public_path__ + "03_short_grey.142987de.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_short_grey.png
// module id = w3BL
// module chunks = 0